'use client';

import React from 'react';

const AnimatedBackground = () => {
  return (
    <div className='absolute inset-0 overflow-hidden'>
      {/* Grid Pattern */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxnIGZpbGw9IiMyMTIxMjEiIGZpbGwtb3BhY2l0eT0iMC40Ij48cGF0aCBkPSJNMzYgMzBoMmwyLTJWMGgtMnYzMHoiLz48cGF0aCBkPSJNMzAgMGgydjJIMzB6TTAgMGgydjJIMHoiLz48L2c+PC9nPjwvc3ZnPg==')] opacity-5"></div>
      
      {/* Floating Gradient Orbs */}
      <div className='absolute top-1/4 right-1/4 h-72 w-72 rounded-full bg-blue-500/20 blur-3xl animate-float'></div>
      <div className='absolute bottom-1/4 left-1/4 h-64 w-64 rounded-full bg-purple-500/20 blur-3xl animate-float-delayed'></div>
      <div className='absolute top-1/2 left-1/2 h-56 w-56 rounded-full bg-emerald-500/20 blur-3xl animate-float-slow'></div>
    </div>
  );
};

export default AnimatedBackground;
